<template>
  <ListingBlock
    v-if="view.dataLength"
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 3)"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import { ListView } from '@/models/docs.list'

defineProps<{
  view: ListView
}>()
</script>

<style lang="scss" scoped>
@media only screen and (max-width: $w-mobile-s) {
  // We repeat the class name to increase specificity.
  :deep(.listing-block__inner.listing-block__inner) {
    --listing-block-items-width-mobile: 220px;
  }
}
</style>
